import Swiper from 'swiper';
import { EffectFade } from 'swiper/modules';

/* eslint-disable import/no-unresolved */
import 'swiper/css';
import 'swiper/css/effect-fade';
/* eslint-enable import/no-unresolved */

import '../../Scss/components/_tab-slider.scss';
import { getElement, getElements, addClass, removeClass } from '../helpers/functions';
import { breakpoints } from '../helpers/constants';
const tabSlider = $el => {
  const $slideContent = getElement('.ce-tabs__slider--content', $el);
  const $slideImage = getElement('.ce-tabs__slider--image', $el);
  const $slideLinks = getElements('.ce-tabs__link', $el);
  const sliderContent = new Swiper($slideContent, {
    slidesPerView: 1,
    simulateTouch: false,
    allowTouchMove: false,
    autoHeight: true,
    breakpoints: {
      [breakpoints.lg]: {
        autoHeight: false
      }
    }
  });
  const handleActiveBtn = e => {
    const {
      activeIndex
    } = e;
    sliderContent.slideTo(activeIndex);
    [...$slideLinks].forEach($link => removeClass($link, '__active'));
    addClass($slideLinks[activeIndex], '__active');
  };
  const sliderImage = new Swiper($slideImage, {
    modules: [EffectFade],
    effect: 'fade',
    simulateTouch: false,
    allowTouchMove: false,
    on: {
      init: handleActiveBtn,
      activeIndexChange: handleActiveBtn
    }
  });
  [...$slideLinks].forEach(($link, index) => {
    $link.addEventListener('click', () => sliderImage.slideTo(index));
  });
};
export default () => {
  getElements('.ce-tabs').forEach($tab => tabSlider($tab));
};